import { useContext } from 'react';
import { DataStateContext } from '../contexts/Data.context';
export const useAlgoliaDataStateContext = () => useContext(DataStateContext);
